import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'checkValueInArray'
})

export class CheckValueInArrayPipe implements PipeTransform {
  transform(value: any, array: any[]): boolean {
    return !!array.find(item => item === value);
  }
}
